import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';

// import config from '../../../../config';


// import PageContent from '../../components/content/PageContent';

import { getCmsPanelRequest, getPanelBySlugAndLanguage } from '../../CmsActions';
import { getPanelModelViewer } from '../../CmsModels';


const getSlug = slugOrArray => (Array.isArray(slugOrArray) ? slugOrArray[0] : slugOrArray);

class CmsPanel2 extends Component {
    componentDidMount() {
        this.setContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if(getSlug(prevProps.slug) !== getSlug(this.props.slug) || prevProps.locale !== this.props.locale || prevProps.intl.locale !== this.props.intl.locale) {
            this.setContent();
        }
    }

    setContent() {
        console.log('Set content', getSlug(this.props.slug));
        return !this.props.isTemplate && !this.props.panel && this.props.dispatch(getCmsPanelRequest(getSlug(this.props.slug), this.props.locale || this.props.intl.locale));
    }

    render() {
        if(this.props.panel) {
            const ModelComponent = getPanelModelViewer(this.props.panel.model);
            return <ModelComponent panel={this.props.panel} {...this.props} />; // eslint-disable-line
        }
        if(Array.isArray(this.props.slug) && this.props.slug[1]) {
            console.log('CmsPanel::: Render alt slug', this.props.slug.slice(1));
            return <CmsPanel slug={this.props.slug.slice(1)} locale={this.props.locale} isTemplate={this.props.isTemplate} />;
        }
        if(process.env.NODE_ENV !== 'production') {
            return `CmsPanel ::: TODO ::: ${this.props.slug}`;
        }
        return null;
    }
}

// Moved in async component
// CmsPage.need = [(params, store, query) => { return getCmsPageRequest(params.slug, params.lang); }];

function mapStateToProps(store, props) {
    return {
        panel: getPanelBySlugAndLanguage(store, getSlug(props.slug), props.locale || store.intl.locale),
    };
}

CmsPanel2.defaultProps = {
    panel: null,
    locale: '',
    isTemplate: false,
};

CmsPanel2.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    slug: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.array,
    ]).isRequired,
    panel: PropTypes.object,
    locale: PropTypes.string,
    isTemplate: PropTypes.bool,
};

const CmsPanel = connect(mapStateToProps)(injectIntl(CmsPanel2));
export default CmsPanel;
